export class BidListFilterSnackBarData {
  constructor(public isFilterByMyAccountsEnabled: boolean, public isBidsFiltered: boolean) {}
}
